/**
 * Axel API client service - wraps the library's createAxelAPIClient.
 *
 * Provides type-safe methods for interacting with the Axel REST API:
 * - Automatic authentication token injection
 * - Centralized error handling
 * - Session, message, and task management
 *
 * Authentication: Uses Cognito JWT exclusively via Authorization: Bearer header.
 * The backend validates JWT via JWKS and uses the same token for all services
 * (Axel API, chat-lambda, MCP, PDM tools).
 */

import {
  createAxelAPIClient,
  type AxelAPIClient as IAxelAPIClient,
  type Message,
} from '@pdm/axel-ui-components';

const API_BASE_URL =
  process.env.REACT_APP_AXEL_API_URL || 'https://axel-api-dev.pdm-automotive.com/v1';

export type { Message };
export type { IAxelAPIClient as AxelAPIClient };

/**
 * Create an authenticated Axel API client using the library's factory.
 *
 * This wraps @pdm/axel-ui-components createAxelAPIClient to ensure consistent
 * implementation across vmto, SupplierConnect, and other consumers.
 */
export function createAxelClient(accessToken?: string, baseURL?: string): IAxelAPIClient {
  return createAxelAPIClient({
    baseURL: baseURL || API_BASE_URL,
    accessToken,
  });
}
